import { withStyles as tssWithStyles } from 'tss-react/mui';
export const withStyles = (styles) => (component) => tssWithStyles(component, styles);
//# sourceMappingURL=tools.js.map